import { AccountTypes, UserRole } from '@shared/utils/base-auth';
import { ShareTypeModel } from '@shared/utils/list-officer';

export abstract class OfficerBaseRequest {
  constructor(
    public EmailAddress: string,
    public EmployeeID: string,
    public FirstName: string,
    public LastName: string,
    public Password: string | null,
    public PhoneNumber: string,
    public RespondToUID: string | null,
    public Role: UserRole,
    public ShareType: ShareTypeModel,
    public TimeZone: string
  ) {}
}
export class CreateOfficerRequest extends OfficerBaseRequest {
  constructor(
    EmailAddress: string,
    EmployeeID: string,
    FirstName: string,
    LastName: string,
    Password: string | null,
    PhoneNumber: string,
    RespondToUID: string | null,
    Role: UserRole,
    ShareType: ShareTypeModel,
    TimeZone: string,
    public AccountType: AccountTypes,
    public SendInvite: boolean
  ) {
    super(EmailAddress, EmployeeID, FirstName, LastName, Password, PhoneNumber, RespondToUID, Role, ShareType, TimeZone);
  }
}

export class AgencyOfficerDetailsRequest extends OfficerBaseRequest {
  constructor(
    EmailAddress: string,
    EmployeeID: string,
    FirstName: string,
    LastName: string,
    Password: string | null,
    PhoneNumber: string,
    RespondToUID: string | null,
    Role: UserRole,
    ShareType: ShareTypeModel,
    TimeZone: string
  ) {
    super(EmailAddress, EmployeeID, FirstName, LastName, Password, PhoneNumber, RespondToUID, Role, ShareType, TimeZone);
  }
}

export class OfficerPersmissionsRequest {
  constructor(public CanDownloadFiles: boolean, public CanUploaderAccess: boolean, public CanWebAccess: boolean, public IsDisabled: boolean) {}
}
